import { render, staticRenderFns } from "./FlexmessageEditor.vue?vue&type=template&id=688b4ed4&scoped=true&"
import script from "./FlexmessageEditor.vue?vue&type=script&lang=js&"
export * from "./FlexmessageEditor.vue?vue&type=script&lang=js&"
import style0 from "./FlexmessageEditor.vue?vue&type=style&index=0&id=688b4ed4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "688b4ed4",
  null
  
)

export default component.exports